import React, { useCallback } from 'react';
import capitalize from 'lodash/capitalize';
import PropTypes from 'prop-types';

import { openWindowAtCenter, safeParsing } from 'Utils/utils';

import { getSignupServiceUrl } from '../utils/api';

import OauthSignupButtonElement from './oauth-signup-button-element';

const signupServiceUrl = getSignupServiceUrl();

const OauthSignupButton = ({ type, onSuccess, onFailure }) => {
	const onButtonClick = useCallback(() => {
		const localStorageKey = `oauth-signup-result-${type}`;
		const url = `${signupServiceUrl}/oauth/${type}`;
		const loginWindow = openWindowAtCenter({
			url,
			w: 650,
			h: 650,
		});
		localStorage.removeItem(localStorageKey);
		const waitForLocalStorage = () => {
			const val = localStorage.getItem(localStorageKey);
			if (val) {
				const res = safeParsing(val, {});
				if (res.error) {
					onFailure(res);
				} else if (res.email) {
					onSuccess(type, res);
				}
				loginWindow.close();
				window.removeEventListener('storage', waitForLocalStorage);
			}
		};
		window.addEventListener('storage', waitForLocalStorage);
	}, [type, onFailure, onSuccess]);
	return (
		<OauthSignupButtonElement
			onClick={onButtonClick}
			icon={`logo-${type}`}
			name={capitalize(type)}
		/>
	);
};

export default OauthSignupButton;

OauthSignupButton.propTypes = {
	type: PropTypes.string.isRequired,
	onSuccess: PropTypes.func.isRequired,
	onFailure: PropTypes.func.isRequired,
};
